// components/Modals.tsx
import React from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { FaCheckCircle } from "react-icons/fa";

interface DeliveryOption {
  id: string;
  provider: string;
  price: number;
  pickup_mins_from_now: number;
  delivery_mins_from_now: number;
}

interface DeliveryOptionProps {
  isDarkMode: boolean;
  isDark: string | undefined;
  confirmDialog: boolean;
  isPopupVisible: boolean;
  isModalOpen: boolean;
  greenFlag: boolean;
  somethingWrong: boolean;
  authNet: string;
  responseData: { orderNo: number } | null;
  deliveryOptions: DeliveryOption[];
  showTime: string;
  delivery: boolean;
  pickUpTime: string;
  deliveryLink: string;
  pause: string | null;
  pauselabel: string | undefined;
  setIsModalOpen: (isModalOpen: boolean) => void;
  setIsPopupVisible: (isPopupVisible: boolean) => void;
  setQuoteId: (quoteId: string) => void;
  setQuoteProvider: (quoteProvider: string) => void;
  setEstimatedTime: (estimatedTime: number) => void;
  setPickUp: (pickUp: number) => void;
  setDeliveryFee: (deliveryFee: string) => void;
  togglePopup: () => void;
  setPause: (pause: any) => void;
}

const DeliveryOptionPopup: React.FC<DeliveryOptionProps> = ({
  isDarkMode,
  isDark,
  confirmDialog,
  isPopupVisible,
  isModalOpen,
  greenFlag,
  somethingWrong,
  authNet,
  responseData,
  deliveryOptions,
  showTime,
  delivery,
  pickUpTime,
  deliveryLink,
  pause,
  pauselabel,
  setIsModalOpen,
  setIsPopupVisible,
  setQuoteId,
  setQuoteProvider,
  setEstimatedTime,
  setPickUp,
  setDeliveryFee,
  togglePopup,
  setPause,
}) => {
  const formatPickupTime = (pickupTime: any) => {
    const [datePart, timePart] = pickupTime.split(" ");
    const [day, month, year] = datePart.split("-");
    const [hours, minutes] = timePart.split(":");

    const date = new Date(year, month - 1, day, hours, minutes);

    const options = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    } as const;

    return datePart + " " + date.toLocaleString("en-US", options);
  };
  // const getModalBg = () =>
  //   isDark === "dark" || (isDarkMode && isDark === "system")
  //     ? "bg-gray-800 text-white"
  //     : "bg-white text-black";

  if (!isPopupVisible && !confirmDialog && pause !== "1") return null;

  return (
    <>
      {isPopupVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: -1,
            }}
          />
          <div>
            {isModalOpen ? (
              <div className="bg-white dark:bg-slate-800 max-w-4xl h-auto p-8 rounded-xl shadow-lg border border-slate-200 dark:border-slate-600 text-slate-900 dark:text-slate-100 relative flex flex-col justify-center items-center">
                <button
                  className="absolute top-4 right-4 text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 text-2xl font-bold"
                  onClick={() => {
                    setIsModalOpen(false);
                    setIsPopupVisible(false);
                  }}
                >
                  &times;
                </button>
                <h3 className="font-bold text-base mb-4 text-center">
                  Delivery Options
                </h3>
                <ul className="w-full space-y-4">
                  {deliveryOptions.map((option: DeliveryOption) => (
                    <li
                      key={option.id}
                      onClick={() => {
                        setIsModalOpen(false);
                        setIsPopupVisible(!isPopupVisible);
                        setQuoteId(option.id);
                        setQuoteProvider(option.provider);
                        setEstimatedTime(option.delivery_mins_from_now);
                        setPickUp(option.pickup_mins_from_now);
                        setDeliveryFee(`${option.price}`);
                        // setGreenFlag(true);
                      }}
                      className="bg-slate-100 dark:bg-slate-700/70 hover:bg-slate-200 dark:hover:bg-slate-600 border border-slate-200 dark:border-slate-600 text-slate-900 dark:text-slate-100 p-4 rounded-lg shadow-sm cursor-pointer flex flex-col justify-center items-start w-full"
                    >
                      <p className="font-semibold">
                        Provider : {option.provider}
                      </p>
                      <p>
                        Price : ${(option.price / 100).toFixed(2)}
                      </p>
                      {/* <p>
                        Pickup Time: {option.pickup_mins_from_now} mins from now
                      </p> */}
                      <p>ETA : aprx. {option.delivery_mins_from_now} mins</p>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}

            {!isModalOpen && !greenFlag && isPopupVisible && !confirmDialog && (
              <div className="bg-white dark:bg-slate-800 w-11/12 max-w-md h-auto p-8 rounded-xl shadow-lg border border-slate-200 dark:border-slate-600 text-slate-900 dark:text-slate-100 relative flex flex-col justify-center items-center">
                <p className="font-bold text-sm text-center mb-4">
                  {authNet ? authNet : "Payment failed, please try again"}
                </p>
                <ButtonPrimary
                  onClick={togglePopup}
                  className="bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 mt-4 rounded"
                >
                  Exit
                </ButtonPrimary>
              </div>
            )}

            {!isModalOpen &&
              greenFlag &&
              (somethingWrong === false ? (
                <div className="bg-white dark:bg-slate-800 w-11/12 max-w-md h-auto p-8 rounded-xl shadow-lg border border-slate-200 dark:border-slate-600 text-slate-900 dark:text-slate-100 relative flex flex-col justify-center items-center">
                  <h1 className="font-bold text-6xl mb-4 text-green-500 flex justify-center items-center">
                    <FaCheckCircle data-testid="check-circle-icon" />
                  </h1>
                  <h3 className="font-bold text-base mb-4 text-center" data-testid="success-message">
                    Order Placed Successfully
                  </h3>
                  <p className="font-bold text-sm text-center mb-4" data-testid="auth-message">
                    {authNet}
                  </p>
                  <div className="flex flex-col sm:flex-row sm:space-x-4 text-center">
                    <span data-testid="order-number">OrderNo: #{responseData?.orderNo}</span>
                    {/* <span>Amount: ${responseData?.totalAmount}</span> */}
                  </div>
                  {delivery === true && (
                    <>
                      <span mt-4 className="text-sm text-center" data-testid="delivery-time">
                        Your Order will be delivered by approximately {showTime}
                      </span>
                      <span mt-4 className="text-sm text-center">
                        Please{" "}
                        <a
                          href={deliveryLink}
                          className="text-blue-500 underline"
                          target="_blank"
                          rel="noopener noreferrer"
                          data-testid="tracking-link"
                        >
                          Click here
                        </a>{" "}
                        to track your order
                      </span>
                    </>
                  )}
                  {delivery === false && (
                    <span mt-4 className="text-sm text-center" data-testid="pickup-time">
                      Your Order will be ready by approximately{" "}
                      {formatPickupTime(pickUpTime)}
                    </span>
                  )}
                  <ButtonPrimary
                    onClick={togglePopup}
                    className="bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 mt-4 rounded"
                  >
                    Exit
                  </ButtonPrimary>
                </div>
              ) : (
                <div className="bg-white dark:bg-slate-800 w-11/12 max-w-md h-auto p-8 rounded-xl shadow-lg border border-slate-200 dark:border-slate-600 text-slate-900 dark:text-slate-100 relative flex flex-col justify-center items-center">
                  <p className="font-bold text-sm text-center mb-4" data-testid="error-message">
                    Something went wrong, please try again.
                  </p>
                  <ButtonPrimary
                    onClick={togglePopup}
                    className="bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 mt-4 rounded"
                  >
                    Exit
                  </ButtonPrimary>
                </div>
              ))}
          </div>
        </div>
      )}
      {isPopupVisible === false && pause === "1" && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={() => setPause(null)}
        >
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: -1,
            }}
          />
          <div>{<div className="alert alert-red">{pauselabel}</div>}</div>
        </div>
      )}
    </>
  );
};

export default DeliveryOptionPopup;
